<template>
<div class="drawerWrap">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
      <el-form-item label="报警内容" prop="content" v-if="isSelectAll">
        <el-input type="textarea" v-html="policeContent"></el-input>
      </el-form-item>
      <el-form-item label="处理类型" prop="type">
        <el-select v-model="form.type" placeholder="请输入处理类型" clearable :disabled="isDisabled">
          <el-option v-for="(item,i) in dealType" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理描述" prop="describe">
          <el-input type="textarea" v-model="form.describe" placeholder="请输入处理描述" maxlength="200" :disabled="isDisabled"></el-input>
      </el-form-item>
      <el-form-item label="处理图片" v-if="!isDisabled">
        <el-upload
          class='upload-demo'
          action
          :limit='2'
          list-type='picture-card'
          :on-remove='handleRemove'
          :file-list='fileList'
          :http-request='handleHttpRequest'
          :before-upload='beforeAvatarUpload'
          :on-change='handleSomeimg'
          >
          <i class='el-icon-plus'></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="botImg" v-if="isDisabled">
      <div class="label">处理图片</div>
      <div class="content" v-if="imgCl.length != 0">
        <div v-for="(url, index) in imgCl" :key="index" class="imgs">
          <img :src="`${baseUrlAddr}/front/device/deviceImg/download?fileName=${url}`" alt="">
        </div>
      </div>
      <div class="cont" v-else>
        无此图片
      </div>
    </div>
  </div>
  <div class="drawerFoot" v-if="!isDisabled">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    policeContent:"",
    handleId: {
      type: [Number, String],
      default: null
    },
    handleType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isSelectAll: {
      type: Boolean,
      default: true
    },
    handleObj: {
      type: Object,
      default: () => {
        return {
          type: '',
          describe: '',
        }
      }
    },
    imgTycl: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      form: {
        type: null,
        describe: null,
        file: []
      },
      imgCl: [],
      // 上传图片
      fileList: [],
      dealType: [{
          value: '1',
          label: '误报'
        },
        {
          value: '2',
          label: '真实报警'
        },
        {
          value: '3',
          label: '故障'
        },
        {
          value: '4',
          label: '测试'
        },
        {
          value: '5',
          label: '其他'
        },
      ],
      formRules: {
        type: [{
          required: true,
          message: "请选择处理类型",
          trigger: "change"
        }],
        describe: [{
          required: true,
          validator: this.validateDescribe,
          trigger: "change"
        }],
      }
    };
  },
  watch: {   // 使用监听的方式，监听数据的变化
      imgTycl (val){
        this.imgCl = val
      }
  },
  created() {
    if (this.isDisabled) {
      let { type, describe } = this.handleObj
      this.form = { type, describe }
    }
  },
  mounted() {
  },
  methods: {
    cancelHandle() { //取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        let par = {
          id: this.handleId,
          type: this.form.type,
          describe: this.form.describe,
          // imgNames: JSON.stringify(this.form.file)
          imgNames: this.form.file.toString()
        }
        this.$emit("update:loading", true);
        this.request.postParamsData("/front/alarm/record/handle", par).then(rs => {
          this.$emit("update:loading", false);
          if (rs.code === 200) {
            this.msg.success('处理成功')
            this.$emit('confirm', rs.code)
          } else if (rs.code == 500) {
            this.msg.warn(rs.msg);
          }
        });
      });
    },
    validateDescribe(rule, value, callback) {
      if ( value === null || value.length === 0) {
        callback(new Error("处理描述不能为空"));
      } else {
        callback();
      }
    },
    // 上传图片========================================================
    handleHttpRequest (obj) {
      this.handleSub()
    },
    handleSomeimg (file, fileList) {
      this.fileList = fileList
    },
    handleSub () {
      let formData = new FormData()
      formData.append('file', this.fileList[this.fileList.length - 1].raw)
      this.request.post('/front/device/deviceImg/upload', formData).then((res) => {
        if (res.code != 200) return
        this.msg.success('上传成功')
        const files = res.data
        this.form.file.push(files)
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPG2 = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning('只支持jpeg或jpg或png格式图片')
      }
      if (!isLt5M) {
        this.$message.warning('请上传10MB以内的图片!')
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M
    },
    handleRemove (file, fileList) {
      let fileID = file.uid
      this.fileList = fileList.filter((val) => {
        return val.uid != fileID
      })
      this.form.file = this.fileList
    },
  }
};
</script>
<style lang="scss" scoped>
  .drawerWrap {
    .drawerBody {
      .botImg {
        padding: 0 50px;
        display: flex;
        box-sizing: border-box;
        .label {
          padding: 10px 0;
          height: 150px;
          box-sizing: border-box;
          margin-right: 12px;
          color: #6e6e6e;
        }
        .content {
          height: 150px;
          width: calc(100% - 68px);
          display: flex;
          justify-content: space-between;
          .imgs {
            img {
              width: 150px;
              height: 150px;
            }
          }
        }
        .cont {
          padding-top: 10px;
          box-sizing: border-box;
        }
      }
    }
  }
</style>
<style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

}
</style>
